import PropTypes from 'prop-types';
import styled from 'styled-components';
import { buildStyledComponent, px2rem } from 'decisiv-ui-utils';

const leftPadding = px2rem(8);
const floatingHeaderHeight = px2rem(189);

/* istanbul ignore next */
const modifierConfig = {
  leftNavExpanded: ({ theme }) => ({
    styles: `
      left: calc(${theme.dimensions.leftNavWidth} + ${leftPadding}) !important;
    `,
  }),
  noTransition: () => ({ styles: 'transition: inherit;' }),
  visible: () => ({
    styles: `
      height: ${floatingHeaderHeight};
      overflow: visible;
    `,
  }),
};

/* istanbul ignore next */
const styles = ({ theme }) => `
  background: ${theme.colors.base.background};
  box-shadow: 0 2px 3px 0 ${theme.colors.base.shadow};
  height: 0;
  left: calc(${theme.dimensions.leftNavWidthCollapsed} + ${leftPadding});
  margin: 0 ${px2rem(-8)};
  overflow: hidden;
  padding: 0 ${px2rem(8)};
  position: fixed;
  right: ${px2rem(8)};
  transition: ${theme.transitions.heightExpand};
  top: ${theme.dimensions.topNavHeight};
  z-index: 1;
`;

const themePropTypes = {
  colors: PropTypes.shape({
    base: PropTypes.shape({
      background: PropTypes.string.isRequired,
      shadow: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  dimensions: PropTypes.shape({
    leftNavWidth: PropTypes.string.isRequired,
    leftNavWidthCollapsed: PropTypes.string.isRequired,
    topNavHeight: PropTypes.string.isRequired,
  }).isRequired,
  transitions: PropTypes.shape({
    heightExpand: PropTypes.string.isRequired,
  }),
};

export default buildStyledComponent(
  'FloatingHeader',
  styled.div,
  styles,
  { modifierConfig, themePropTypes },
);



// WEBPACK FOOTER //
// ./elements/FloatingHeader/index.js